/* ============================================================
   REFORMER editorial — interactions
   reveal-on-scroll · AJAX cart + drawer · quick-add · sticky PDP bar
   ============================================================ */
(function () {
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- helpers ---------- */
  function money(cents) {
    var n = cents / 100;
    return '$' + (n % 1 === 0 ? n.toFixed(0) : n.toFixed(2));
  }
  function colorHex(name) {
    var v = (name || '').toLowerCase();
    if (v.indexOf('black') > -1) return '#1c1b19';
    if (v.indexOf('maple') > -1) return '#a9744c';
    if (v.indexOf('mauve') > -1) return '#b6a1a4';
    if (v.indexOf('olive') > -1) return '#6d6d4c';
    if (v.indexOf('fog') > -1 || v.indexOf('grey') > -1 || v.indexOf('gray') > -1) return '#cdcec8';
    if (v.indexOf('clay') > -1) return '#b78d73';
    if (v.indexOf('sand') > -1 || v.indexOf('heather') > -1 || v.indexOf('beige') > -1 || v.indexOf('nude') > -1) return '#d6c5a9';
    if (v.indexOf('white') > -1 || v.indexOf('cream') > -1) return '#f0ede4';
    if (v.indexOf('navy') > -1 || v.indexOf('blue') > -1) return '#2b3140';
    return '#cdc9bd';
  }
  function lenisStop() { if (window.rfLenis) window.rfLenis.stop(); }
  function lenisStart() { if (window.rfLenis) window.rfLenis.start(); }

  /* ---------- smooth scroll (Lenis) ---------- */
  function initLenis() {
    if (reduce || typeof Lenis === 'undefined') return;
    var lenis = new Lenis({
      duration: 1.15,
      easing: function (t) { return Math.min(1, 1.001 - Math.pow(2, -10 * t)); },
      smoothWheel: true, wheelMultiplier: 1, touchMultiplier: 1.6
    });
    window.rfLenis = lenis;
    function raf(time) { lenis.raf(time); requestAnimationFrame(raf); }
    requestAnimationFrame(raf);
    /* drive scroll-based reveals / sticky bar while Lenis animates */
    lenis.on('scroll', function () { window.dispatchEvent(new Event('scroll')); });
  }

  /* ---------- intro / loading veil ---------- */
  function initIntro() {
    var intro = document.querySelector('[data-rf-intro]');
    if (!intro) return;
    try { if (reduce || sessionStorage.getItem('rf_intro_seen')) { intro.remove(); return; } } catch (e) {}
    try { sessionStorage.setItem('rf_intro_seen', '1'); } catch (e) {}
    lenisStop(); document.body.style.overflow = 'hidden';
    setTimeout(function () {
      intro.classList.add('is-hiding');
      lenisStart(); document.body.style.overflow = '';
      setTimeout(function () { if (intro && intro.parentNode) intro.parentNode.removeChild(intro); }, 900);
    }, 1750);
  }

  /* ---------- reveal on scroll (scroll-based; robust everywhere) ---------- */
  function initReveal() {
    var els = [].slice.call(document.querySelectorAll('.rf-reveal'));
    if (reduce) { els.forEach(function (e) { e.classList.add('is-in'); }); return; }
    function check() {
      var vh = window.innerHeight || document.documentElement.clientHeight || 800;
      var toReveal = [];
      for (var i = 0; i < els.length; i++) {
        var r = els[i].getBoundingClientRect();
        if (r.top < vh * 0.92 && r.bottom > 0) toReveal.push(els[i]);
      }
      toReveal.forEach(function (el, idx) {
        el.style.transitionDelay = (Math.min(idx, 5) * 0.07) + 's'; /* subtle cascade */
        el.classList.add('is-in');
      });
      if (toReveal.length) els = els.filter(function (e) { return !e.classList.contains('is-in'); });
    }
    check();
    window.addEventListener('scroll', check, { passive: true });
    window.addEventListener('resize', check);
    window.addEventListener('load', check);
    setTimeout(check, 400); /* safety after fonts/layout settle */
  }

  /* ---------- cart drawer ---------- */
  var drawer, overlay, drawerBody;
  function openDrawer() { if (drawer) { drawer.classList.add('is-open'); overlay.classList.add('is-open'); document.body.style.overflow = 'hidden'; lenisStop(); } }
  function closeDrawer() { if (drawer) { drawer.classList.remove('is-open'); overlay.classList.remove('is-open'); document.body.style.overflow = ''; lenisStart(); } }
  function updateCount(cart) {
    document.querySelectorAll('[data-rf-bag]').forEach(function (el) { el.textContent = 'Bag (' + cart.item_count + ')'; });
  }
  function renderDrawer(cart) {
    updateCount(cart);
    if (!drawerBody) return;
    var sub = document.querySelector('[data-rf-subtotal]');
    if (sub) sub.textContent = money(cart.total_price);
    if (!cart.items.length) {
      drawerBody.innerHTML = '<p class="rf-drawer-empty">Your bag is empty.</p>';
      return;
    }
    drawerBody.innerHTML = cart.items.map(function (i) {
      var img = i.image ? '<img src="' + i.image.replace(/(\.[a-z]+)(\?|$)/i, '_160x$1$2') + '" alt="">' : '';
      var opts = (i.options_with_values || []).map(function (o) { return o.value; }).join(' · ');
      return '<div class="rf-drawer-item">' +
        '<div class="rf-drawer-thumb">' + img + '</div>' +
        '<div class="rf-drawer-info">' +
        '<div class="rf-drawer-row"><span>' + i.product_title + '</span><span>' + money(i.final_line_price) + '</span></div>' +
        '<div class="rf-drawer-meta">' + opts + '</div>' +
        '<button class="rf-drawer-remove" data-rf-remove="' + i.key + '">Remove</button>' +
        '</div></div>';
    }).join('');
  }
  function fetchCart(cb) {
    fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (c) { renderDrawer(c); if (cb) cb(c); });
  }
  function addToCart(id, qty, cb) {
    return fetch('/cart/add.js', {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: id, quantity: qty || 1 })
    }).then(function (r) { return r.json(); }).then(function () {
      fetchCart(function (c) { if (cb) cb(c); openDrawer(); });
    });
  }
  function removeItem(key) {
    fetch('/cart/change.js', {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: 0 })
    }).then(function (r) { return r.json(); }).then(renderDrawer);
  }
  window.rfAddToCart = addToCart;
  window.rfOpenDrawer = openDrawer;

  function wireDrawer() {
    drawer = document.querySelector('[data-rf-drawer]');
    overlay = document.querySelector('[data-rf-drawer-overlay]');
    drawerBody = document.querySelector('[data-rf-drawer-body]');
    if (!drawer) return;
    overlay.addEventListener('click', closeDrawer);
    var closeBtn = drawer.querySelector('[data-rf-drawer-close]');
    if (closeBtn) closeBtn.addEventListener('click', closeDrawer);
    document.querySelectorAll('[data-rf-bag-open]').forEach(function (a) {
      a.addEventListener('click', function (e) { e.preventDefault(); openDrawer(); });
    });
    drawer.addEventListener('click', function (e) {
      var rm = e.target.closest('[data-rf-remove]');
      if (rm) removeItem(rm.getAttribute('data-rf-remove'));
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeDrawer(); });
  }

  /* ---------- quick-add modal ---------- */
  var qa, qaState = { product: null, sel: {} };
  function wireQuickAdd() {
    qa = document.querySelector('[data-rf-qa]');
    if (!qa) return;
    qa.querySelector('[data-rf-qa-overlay]').addEventListener('click', closeQA);
    qa.querySelector('[data-rf-qa-close]').addEventListener('click', closeQA);

    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-rf-quickadd]');
      if (!btn) return;
      e.preventDefault(); e.stopPropagation();
      openQA(btn.getAttribute('data-rf-quickadd'));
    });
  }
  function closeQA() { if (qa) { qa.hidden = true; document.body.style.overflow = ''; lenisStart(); } }
  function optIndex(product, kind) {
    for (var i = 0; i < product.options.length; i++) {
      var o = product.options[i];
      var n = (typeof o === 'string' ? o : (o.name || '')).toLowerCase();
      if (kind === 'color' && (n.indexOf('color') > -1 || n.indexOf('colour') > -1)) return i;
      if (kind === 'size' && n.indexOf('size') > -1) return i;
    }
    return -1;
  }
  function openQA(handle) {
    fetch('/products/' + handle + '.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (p) {
        qaState.product = p; qaState.sel = {};
        var ci = optIndex(p, 'color'), si = optIndex(p, 'size');
        var img = p.featured_image ? p.featured_image.replace(/(\.[a-z]+)(\?|$)/i, '_600x$1$2') : '';
        var html = '' +
          '<div class="rf-qa-media">' + (img ? '<img src="' + img + '" alt="">' : '') + '</div>' +
          '<div class="rf-qa-info">' +
          '<div class="rf-qa-name">' + p.title + '</div>' +
          '<div class="rf-qa-price" data-rf-qa-price>' + money(p.price) + '</div>';
        if (ci > -1) {
          html += '<div class="rf-pdp-label">Color — <span data-rf-qa-colorname></span></div><div class="rf-pdp-swatches">';
          uniqueValues(p, ci).forEach(function (v) {
            html += '<button type="button" class="rf-pdp-sw" data-qa-opt="' + ci + '" data-qa-val="' + esc(v) + '" title="' + esc(v) + '" style="background:' + colorHex(v) + '"></button>';
          });
          html += '</div>';
        }
        if (si > -1) {
          html += '<div class="rf-pdp-label">Size</div><div class="rf-pdp-sizes">';
          uniqueValues(p, si).forEach(function (v) {
            html += '<button type="button" class="rf-size" data-qa-opt="' + si + '" data-qa-val="' + esc(v) + '">' + v + '</button>';
          });
          html += '</div>';
        }
        html += '<button type="button" class="rf-addbtn" data-rf-qa-add disabled>Select options</button>' +
          '<a href="/products/' + handle + '" class="rf-qa-viewlink">View full details</a>' +
          '</div>';
        qa.querySelector('[data-rf-qa-content]').innerHTML = html;
        // preselect first available if single option combos
        wireQAButtons();
        qa.hidden = false; document.body.style.overflow = 'hidden'; lenisStop();
      });
  }
  function uniqueValues(p, idx) {
    var seen = {}, out = [];
    p.variants.forEach(function (v) { var val = v.options[idx]; if (!seen[val]) { seen[val] = 1; out.push(val); } });
    return out;
  }
  function esc(s) { return String(s).replace(/"/g, '&quot;'); }
  function setQAImage() {
    var p = qaState.product, ci = optIndex(p, 'color');
    if (ci < 0) return;
    var colorVal = qaState.sel[ci];
    if (!colorVal) return;
    var src = null;
    for (var i = 0; i < p.variants.length; i++) {
      var v = p.variants[i];
      if (v.options[ci] === colorVal && v.featured_image && v.featured_image.src) { src = v.featured_image.src; break; }
    }
    if (!src) return;
    var media = qa.querySelector('.rf-qa-media');
    if (!media) return;
    var img = media.querySelector('img');
    var full = src.replace(/(\.[a-z0-9]+)(\?|$)/i, '_600x$1$2');
    if (!img) { img = document.createElement('img'); media.appendChild(img); }
    img.style.transition = 'opacity .3s ease';
    img.style.opacity = '0';
    var pre = new Image();
    pre.onload = function () { img.src = full; img.style.opacity = '1'; };
    pre.onerror = function () { img.src = src; img.style.opacity = '1'; };
    pre.src = full;
  }
  function wireQAButtons() {
    var content = qa.querySelector('[data-rf-qa-content]');
    content.querySelectorAll('[data-qa-opt]').forEach(function (b) {
      b.addEventListener('click', function () {
        var pos = b.getAttribute('data-qa-opt');
        qaState.sel[pos] = b.getAttribute('data-qa-val');
        content.querySelectorAll('[data-qa-opt="' + pos + '"]').forEach(function (x) { x.classList.remove('is-active'); });
        b.classList.add('is-active');
        var cn = content.querySelector('[data-rf-qa-colorname]');
        var ci = optIndex(qaState.product, 'color');
        if (cn && qaState.sel[ci]) cn.textContent = qaState.sel[ci];
        if (+pos === ci) setQAImage();
        updateQA();
      });
    });
  }
  function currentVariant() {
    var p = qaState.product;
    return p.variants.find(function (v) {
      return Object.keys(qaState.sel).every(function (pos) { return v.options[pos] === qaState.sel[pos]; })
        && Object.keys(qaState.sel).length === p.options.length;
    });
  }
  function updateQA() {
    var addBtn = qa.querySelector('[data-rf-qa-add]');
    var v = currentVariant();
    var priceEl = qa.querySelector('[data-rf-qa-price]');
    if (v) {
      if (priceEl) priceEl.textContent = money(v.price);
      if (v.available) { addBtn.disabled = false; addBtn.textContent = 'Add to Bag — ' + money(v.price); }
      else { addBtn.disabled = true; addBtn.textContent = 'Sold Out'; }
      addBtn.onclick = function () {
        addBtn.textContent = 'Adding…';
        addToCart(v.id, 1, function () { closeQA(); });
      };
    } else {
      addBtn.disabled = true; addBtn.textContent = 'Select options';
    }
  }

  /* ---------- search overlay + predictive ---------- */
  function wireSearch() {
    var panel = document.querySelector('[data-rf-search]');
    var scrim = document.querySelector('[data-rf-search-overlay]');
    if (!panel || !scrim) return;
    var input = panel.querySelector('[data-rf-search-input]');
    var results = panel.querySelector('[data-rf-search-results]');
    var viewall = panel.querySelector('[data-rf-search-viewall]');
    var mobileMenu = document.querySelector('[data-rf-mobile]');
    var burger = document.querySelector('[data-rf-burger]');

    function open(e) {
      if (e) e.preventDefault();
      if (mobileMenu && !mobileMenu.hidden) { mobileMenu.hidden = true; if (burger) burger.classList.remove('is-open'); }
      panel.classList.add('is-open'); scrim.classList.add('is-open');
      document.body.style.overflow = 'hidden'; lenisStop();
      setTimeout(function () { input.focus(); }, 260);
    }
    function close() {
      panel.classList.remove('is-open'); scrim.classList.remove('is-open');
      document.body.style.overflow = ''; lenisStart();
    }
    document.querySelectorAll('[data-rf-search-open]').forEach(function (a) { a.addEventListener('click', open); });
    scrim.addEventListener('click', close);
    panel.querySelector('[data-rf-search-close]').addEventListener('click', close);
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && panel.classList.contains('is-open')) close(); });

    var t;
    input.addEventListener('input', function () {
      var q = input.value.trim();
      clearTimeout(t);
      if (q.length < 2) { results.innerHTML = ''; viewall.hidden = true; return; }
      t = setTimeout(function () {
        fetch('/search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=8&resources[options][unavailable_products]=last', { credentials: 'same-origin' })
          .then(function (r) { return r.json(); })
          .then(function (d) {
            var prods = (d.resources && d.resources.results && d.resources.results.products) || [];
            if (!prods.length) { results.innerHTML = '<p class="rf-search-empty">No results found.</p>'; viewall.hidden = true; return; }
            results.innerHTML = prods.map(function (p) {
              var img = p.image ? '<img class="rf-cover" src="' + p.image.replace(/(\.[a-z]+)(\?|$)/i, '_400x$1$2') + '" alt="" loading="lazy">' : '';
              return '<a class="rf-search-item" href="' + p.url + '"><div class="rf-slot rf-card-shot">' + img + '</div><div class="rf-search-item-name">' + p.title + '</div></a>';
            }).join('');
            viewall.hidden = false; viewall.href = '/search?q=' + encodeURIComponent(q);
            viewall.textContent = 'View all results for “' + q + '”';
          }).catch(function () {});
      }, 220);
    });
  }

  /* ---------- sticky PDP add bar (scroll-based) ---------- */
  function initStickyBar() {
    var bar = document.querySelector('[data-rf-stickybar]');
    var anchor = document.querySelector('[data-rf-add]');
    if (!bar || !anchor) return;
    function check() {
      var r = anchor.getBoundingClientRect();
      bar.classList.toggle('is-visible', r.bottom < 4);
    }
    check();
    window.addEventListener('scroll', check, { passive: true });
    window.addEventListener('resize', check);
  }

  /* ---------- init ---------- */
  function init() { initLenis(); initReveal(); wireDrawer(); wireQuickAdd(); wireSearch(); initStickyBar(); fetchCart(); initIntro(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
